import React from "react";

const DAY_COVER = "https://customer-assets.emergentagent.com/job_caf-neon-experience/artifacts/ubrbyxfc_file_00000000037871fd9462bbd4e1057233.png";

export default function About() {
  return (
    <section id="about" data-testid="about-section" className="relative py-24 md:py-32 px-5 md:px-10 max-w-7xl mx-auto">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-center">
        {/* Cover */}
        <div className="lg:col-span-5 reveal">
          <div className="relative group">
            <div className="absolute -inset-2 bg-gradient-to-br from-[#00F0FF]/30 via-transparent to-[#FF00E5]/30 blur-2xl opacity-60 group-hover:opacity-100 transition-opacity" aria-hidden="true" />
            <img
              src={DAY_COVER}
              alt="Concept and Formality — day album cover"
              data-testid="about-cover"
              className="relative w-full h-auto border border-white/10"
            />
            <div className="mt-4 flex items-center justify-between font-mono-display text-[10px] uppercase tracking-[0.3em] text-white/55">
              <span>Stephen Austin</span>
              <span className="text-[#FF00E5]">© C.A.F. 2026</span>
            </div>
          </div>
        </div>

        {/* Bio */}
        <div className="lg:col-span-7 reveal" style={{ transitionDelay: "120ms" }}>
          <span className="font-mono-display text-[11px] uppercase tracking-[0.4em] text-[#00F0FF]">
            06 — The Project
          </span>
          <h2 className="font-display font-black text-4xl sm:text-5xl md:text-6xl mt-3 leading-[0.95]">
            BUILT FROM<br />
            <span className="text-gradient-neon">CONTRAST.</span>
          </h2>

          <div className="mt-7 space-y-5 text-white/75 text-base md:text-lg leading-relaxed font-body max-w-2xl">
            <p>
              <span className="font-display font-bold text-cream-soft">Concept And Formality</span> is the solo
              vision of <span className="text-[#FF00E5]">Stephen Austin</span>, a progressive pop-punk-meets-metal
              project born out of Las Vegas — a city of neon excess and quiet desert dread.
            </p>
            <p>
              The sound lives in the friction between two opposing worlds: the dreamlike pastels of anime
              and the corroded chrome of early 2000s alternative. Pop-punk hooks bleed into blast beats. Heartbreak
              becomes a guitar solo. Beach sunsets turn into nightclub strobes.
            </p>
            <p>
              Drawing equally from <em className="text-[#00F0FF] not-italic">Visual Kei</em>, gaming
              soundtracks, classic emo, pop punk, and modern progressive metal, C.A.F. tells emotional stories at
              cinematic scale — every track designed to feel like the closing scene of something you
              didn&apos;t want to end.
            </p>
            <p className="font-mono-display text-sm uppercase tracking-[0.15em] text-[#FF00E5]">
              The first full record drops in 2026.
            </p>
          </div>

          {/* Stat row */}
          <div className="mt-10 grid grid-cols-3 gap-4 border-t border-white/10 pt-7">
            {[
              { num: "07", label: "Tracks" },
              { num: "01", label: "Vision" },
              { num: "∞", label: "Decibels" },
            ].map((s) => (
              <div key={s.label} className="text-center md:text-left">
                <div className="font-display font-black text-3xl md:text-4xl text-gradient-neon">{s.num}</div>
                <div className="font-mono-display text-[10px] uppercase tracking-[0.25em] text-white/55 mt-1">
                  {s.label}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
